/**
 * @format
 * @description Accepts an argument and attempts to convert its value to a number
 */

function convertToNumber(number: unknown, radix = 10): number | undefined {
  // Return number
  let returnNumber;

  // Check to see if argument is a string
  if (typeof number === 'string' && number.trim() !== '') {
    // Attempt to parse the string
    try {
      let parsedNumber;
      if (number.split('.')[1] === undefined) {
        parsedNumber = Number.parseInt(number, radix);
      } else {
        parsedNumber = Number.parseFloat(number);
      }

      // Ensure NaN did not occur
      if (!Number.isNaN(parsedNumber)) {
        // Set the number
        returnNumber = parsedNumber;
      }
    } catch {
      return returnNumber;
    }
  } else if (typeof number === 'number') {
    returnNumber = number;
  } else if (typeof number === 'boolean' && number) {
    returnNumber = 1;
  } else if (typeof number === 'boolean' && !number) {
    returnNumber = 0;
  } else {
    // Return NaN because we don't know what to do with it
    returnNumber = Number.NaN;
  }

  // Return the number
  return returnNumber;
}

/**
 * @description
 * Method that checks whether a given argument is 'truthy' which means it will check multiple types and values which
 * would evaluate to `true`. It will return `false` by default.
 */
function isTruthy(inArgument: unknown): boolean {
  // Default flag to false
  let returnBoolean = false;

  // Test for String
  if (typeof inArgument === 'string') {
    // Normalize the String
    inArgument = inArgument.toLowerCase().trim();

    // Check the value
    if (inArgument === 'true' || inArgument === 'yes' || inArgument === 'y' || inArgument === '1') {
      returnBoolean = true;
    }
    // Test for Boolean
  } else if (typeof inArgument === 'boolean') {
    // Check the value
    returnBoolean = inArgument;
    // Test for Integer
  } else if (typeof inArgument === 'number') {
    // Check the value
    returnBoolean = inArgument === 1;
    // Test for Object; NOTE: "null" returns a typeof as "object" so we need to be careful here
  } else if (typeof inArgument === 'object' && inArgument !== null) {
    if (Array.isArray(inArgument)) {
      returnBoolean = inArgument.length > 0;
    } else {
      returnBoolean = Object.keys(inArgument).length > 0;
    }
  }

  // Return flag
  return returnBoolean;
}

export { convertToNumber, isTruthy };
